export default "__VITE_ASSET__CUmBJE9I__"